import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a7f4657"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "version" }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = { class: "vu_content" }
const _hoisted_4 = { class: "vu_content_type" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vu_content_type_tds" }, "版本类别", -1))
const _hoisted_6 = { class: "wrap" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "main" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "desc" }
const _hoisted_11 = { class: "price" }
const _hoisted_12 = { class: "num" }
const _hoisted_13 = { class: "icon" }
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "vu_content_feature" }
const _hoisted_17 = { class: "vctt_tb" }
const _hoisted_18 = { class: "vu_content_feature" }
const _hoisted_19 = { class: "vctt_tb" }
const _hoisted_20 = { class: "vu_content_feature" }
const _hoisted_21 = { class: "vctt_tb" }
const _hoisted_22 = { class: "vu_content_feature" }
const _hoisted_23 = { class: "vctt_tb" }
const _hoisted_24 = { class: "vu_content_feature" }
const _hoisted_25 = { class: "vctt_tb" }
const _hoisted_26 = { class: "vu_content_feature" }
const _hoisted_27 = { class: "vctt_tb" }
const _hoisted_28 = { class: "vu_content_feature" }
const _hoisted_29 = { class: "vctt_tb" }
const _hoisted_30 = { class: "vu_content_feature" }
const _hoisted_31 = { class: "vctt_tb" }
const _hoisted_32 = { class: "vu_content_feature" }
const _hoisted_33 = { class: "vctt_tb" }
const _hoisted_34 = { class: "vu_content_feature" }
const _hoisted_35 = { class: "vctt_tb" }
const _hoisted_36 = { class: "vu_content_feature" }
const _hoisted_37 = { class: "vctt_tb" }
const _hoisted_38 = { class: "vu_content_feature" }
const _hoisted_39 = { class: "vctt_tb" }
const _hoisted_40 = { class: "vu_content_feature" }
const _hoisted_41 = { class: "vctt_tb" }
const _hoisted_42 = { class: "vu_content_feature" }
const _hoisted_43 = { class: "vctt_tb" }
const _hoisted_44 = { class: "vu_content_feature" }
const _hoisted_45 = { class: "vctt_tb" }
const _hoisted_46 = { class: "vu_content_feature" }
const _hoisted_47 = { class: "vctt_tb" }
const _hoisted_48 = { class: "vu_content_feature" }
const _hoisted_49 = { class: "vctt_tb" }
const _hoisted_50 = { class: "vu_content_feature" }
const _hoisted_51 = { class: "vctt_tb" }

import { computed, ref, withDefaults } from 'vue';
import { Version, VersionRoleInfo } from '../types';
import { planV1, planV2, planV3, planV4, planT1, planT2, planT3, planT4, planC1, planC2, planC3, planC4 } from '@/assets';
import { useDebounce } from '@/hooks/useDebounce';
import NextHead from './versionCell/NextHead.vue';
import NextTd from './versionCell/NextTd.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NextVersion',
  props: {
    list: { default: () => [] },
    plan: { default: () => [] },
    title: null,
    status: null
  },
  setup(__props: any) {

const props = __props as { list: Version[], plan: VersionRoleInfo[], title: any, status: number };

const PLANBG = [planV1, planV2, planV3, planV4];
const TICON = [planT1, planT2, planT3, planT4];
const CION = [planC1, planC2, planC3, planC4];

const planList = computed(() => props.plan);
const buyUrl =
  'https://www13.53kf.com/webCompany.php?arg=10561881&kf_sign=TEwNzMTY2OI0NDE1MDkxODU5MTg3MDAzNzI1NjE4ODE%253D&style=1';
const buy = useDebounce(() => {
  window.open(buyUrl);
});
const versionList = computed(() => props.list);

const showTable = ref<boolean[]>([]);
for (let i = 0; i < props.title.length; i++) {
  showTable.value[props.title[i]] = true;
}
const openTable = (index: string) => {
  showTable.value[index] = !showTable.value[index];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(planList), (plan, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "vu_content_type_td plan",
              key: index
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: PLANBG[index],
                  alt: "",
                  class: "bg-img"
                }, null, 8, _hoisted_7),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(plan.role_type), 1),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(plan.english), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(plan.origin_price ? `¥${plan.origin_price}` : ''), 1),
                    _createTextVNode(" " + _toDisplayString(plan.origin_price ? `/${plan.validity_time}` : ''), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  (!props.status)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: TICON[index],
                        class: "img-v"
                      }, null, 8, _hoisted_14))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: CION[index],
                        class: "img-v"
                      }, null, 8, _hoisted_15))
                ])
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(NextHead, {
              title: "资源配置",
              show: showTable.value,
              "onClick:updata": openTable
            }, null, 8, ["show"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "vctt_tb",
              key: index
            }, [
              _createVNode(NextTd, {
                "node-data": item.resources_config,
                show: showTable.value['资源配置']
              }, null, 8, ["node-data", "show"])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(NextHead, {
              title: "直播模式",
              show: showTable.value,
              "onClick:updata": openTable
            }, null, 8, ["show"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "vctt_tb",
              key: index
            }, [
              _createVNode(NextTd, {
                "node-data": item.mode,
                show: showTable.value['直播模式']
              }, null, 8, ["node-data", "show"])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createVNode(NextHead, {
              title: "直播发起",
              show: showTable.value,
              "onClick:updata": openTable
            }, null, 8, ["show"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "vctt_tb",
              key: index
            }, [
              (item.live)
                ? (_openBlock(), _createBlock(NextTd, {
                    key: 0,
                    "node-data": item.live,
                    show: showTable.value['直播发起']
                  }, null, 8, ["node-data", "show"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createVNode(NextHead, {
              title: "页面装饰",
              show: showTable.value,
              "onClick:updata": openTable
            }, null, 8, ["show"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "vctt_tb",
              key: index
            }, [
              _createVNode(NextTd, {
                "node-data": item.decorate,
                show: showTable.value['页面装饰']
              }, null, 8, ["node-data", "show"])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createVNode(NextHead, {
              title: "多维互动",
              show: showTable.value,
              "onClick:updata": openTable
            }, null, 8, ["show"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "vctt_tb",
              key: index
            }, [
              _createVNode(NextTd, {
                "node-data": item.interaction,
                show: showTable.value['多维互动']
              }, null, 8, ["node-data", "show"])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createVNode(NextHead, {
              title: "营销推广",
              show: showTable.value,
              "onClick:updata": openTable
            }, null, 8, ["show"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "vctt_tb",
              key: index
            }, [
              (item.marketing)
                ? (_openBlock(), _createBlock(NextTd, {
                    key: 0,
                    "node-data": item.marketing,
                    show: showTable.value['营销推广']
                  }, null, 8, ["node-data", "show"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createVNode(NextHead, {
              title: "报名注册",
              show: showTable.value,
              "onClick:updata": openTable
            }, null, 8, ["show"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "vctt_tb",
              key: index
            }, [
              (item.signup)
                ? (_openBlock(), _createBlock(NextTd, {
                    key: 0,
                    "node-data": item.signup,
                    show: showTable.value['报名注册']
                  }, null, 8, ["node-data", "show"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createVNode(NextHead, {
              title: "高级功能",
              show: showTable.value,
              "onClick:updata": openTable
            }, null, 8, ["show"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "vctt_tb",
              key: index
            }, [
              (item.setting)
                ? (_openBlock(), _createBlock(NextTd, {
                    key: 0,
                    "node-data": item.setting,
                    show: showTable.value['高级功能']
                  }, null, 8, ["node-data", "show"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createVNode(NextHead, {
              title: "授权观看",
              show: showTable.value,
              "onClick:updata": openTable
            }, null, 8, ["show"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "vctt_tb",
              key: index
            }, [
              (item.authorized_viewing)
                ? (_openBlock(), _createBlock(NextTd, {
                    key: 0,
                    "node-data": item.authorized_viewing,
                    show: showTable.value['授权观看']
                  }, null, 8, ["node-data", "show"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createVNode(NextHead, {
              title: "媒体库",
              show: showTable.value,
              "onClick:updata": openTable
            }, null, 8, ["show"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "vctt_tb",
              key: index
            }, [
              (item.media_library)
                ? (_openBlock(), _createBlock(NextTd, {
                    key: 0,
                    "node-data": item.media_library,
                    show: showTable.value['媒体库']
                  }, null, 8, ["node-data", "show"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createVNode(NextHead, {
              title: "安全管控",
              show: showTable.value,
              "onClick:updata": openTable
            }, null, 8, ["show"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "vctt_tb",
              key: index
            }, [
              (item.safety_control)
                ? (_openBlock(), _createBlock(NextTd, {
                    key: 0,
                    "node-data": item.safety_control,
                    show: showTable.value['安全管控']
                  }, null, 8, ["node-data", "show"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createVNode(NextHead, {
              title: "互动直播",
              show: showTable.value,
              "onClick:updata": openTable
            }, null, 8, ["show"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "vctt_tb",
              key: index
            }, [
              (item.interactive_live_broadcast)
                ? (_openBlock(), _createBlock(NextTd, {
                    key: 0,
                    "node-data": item.interactive_live_broadcast,
                    show: showTable.value['互动直播']
                  }, null, 8, ["node-data", "show"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createVNode(NextHead, {
              title: "应用中心",
              show: showTable.value,
              "onClick:updata": openTable
            }, null, 8, ["show"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "vctt_tb",
              key: index
            }, [
              (item.application_center)
                ? (_openBlock(), _createBlock(NextTd, {
                    key: 0,
                    "node-data": item.application_center,
                    show: showTable.value['应用中心']
                  }, null, 8, ["node-data", "show"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createVNode(NextHead, {
              title: "数据统计",
              show: showTable.value,
              "onClick:updata": openTable
            }, null, 8, ["show"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "vctt_tb",
              key: index
            }, [
              _createVNode(NextTd, {
                "node-data": item.data,
                show: showTable.value['数据统计']
              }, null, 8, ["node-data", "show"])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createVNode(NextHead, {
              title: "外部集成API",
              show: showTable.value,
              "onClick:updata": openTable
            }, null, 8, ["show"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "vctt_tb",
              key: index
            }, [
              (item.external_integration_api)
                ? (_openBlock(), _createBlock(NextTd, {
                    key: 0,
                    "node-data": item.external_integration_api,
                    show: showTable.value['外部集成API']
                  }, null, 8, ["node-data", "show"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createVNode(NextHead, {
              title: "品牌定制",
              show: showTable.value,
              "onClick:updata": openTable
            }, null, 8, ["show"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "vctt_tb",
              key: index
            }, [
              _createVNode(NextTd, {
                "node-data": item.customized,
                show: showTable.value['品牌定制']
              }, null, 8, ["node-data", "show"])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createVNode(NextHead, {
              title: "私有部署",
              show: showTable.value,
              "onClick:updata": openTable
            }, null, 8, ["show"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "vctt_tb",
              key: index
            }, [
              _createVNode(NextTd, {
                "node-data": item.private,
                show: showTable.value['私有部署']
              }, null, 8, ["node-data", "show"])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createVNode(NextHead, {
              title: "增值服务",
              show: showTable.value,
              "onClick:updata": openTable
            }, null, 8, ["show"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "vctt_tb",
              key: index
            }, [
              (item.value_added_services)
                ? (_openBlock(), _createBlock(NextTd, {
                    key: 0,
                    "node-data": item.value_added_services,
                    show: showTable.value['增值服务']
                  }, null, 8, ["node-data", "show"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ], 512), [
      [_vShow, Object.keys(_unref(versionList)).length]
    ])
  ]))
}
}

})